<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "门店订单号",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入门店订单号"
          },

        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            url: api.system.seStore,
          },
          {
            label: "订单状态",
            prop: "status",
            width: "120",
            type: 'select',
            span: 12,
            data: this.$utils.getCacheStatus('deUuOrder.status'),
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "编辑",
          code: "update",
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: "门店名称", prop: "storeName", width: "150", align: "center",},
          {label: "门店订单号", prop: "soOrder", width: "200", align: "center"},
          {label: "UU订单号", prop: "orderNo", width: "200", align: "center",},
          {label: "订单总金额（优惠前）", prop: "totalMoney", width: "240", align: "center",},
          {label: "实际需要支付", prop: "needPaymoney", width: "240", align: "center",},
          {label: "总优惠金额", prop: "totalPriceoff", width: "240", align: "center",},
          {label: "配送距离(米)", prop: "distance", width: "120", align: "center",},
          {label: "跑腿费", prop: "freightMoney", width: "120", align: "center",},
          {label: "优惠券金额", prop: "couponAmount", width: "120", align: "center",},
          {label: "骑手名称", prop: "driverName", width: "120", align: "center",},
          {label: "骑手工号", prop: "driverJobnum", width: "120", align: "center",},
          {label: "骑手电话", prop: "driverMobile", width: "120", align: "center",},
          {label: "下单时间", prop: "createDttm", width: "150", align: "center",},
          {
            label: "状态",
            prop: "status",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('deUuOrder.status'),
          },
          {label: "订单取消原因", prop: "reason", width: "240", align: "center",},
        ],
        url: api.distribution.uuDistributionRecord,
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
  },
  methods: {},
};
</script>




// WEBPACK FOOTER //
// src/page/delivery/uu/Record.vue